import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function";
import type {DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {getDisplayId} from "./documentData.function";

const SupplierDocumentDetailsDTO = ({details, translate}: DocumentDetailsProps) => (
    <DocumentDataGrid>
        {/* the description of a supplier document is the supplier's name */}
        {details.description &&
            <DocumentDataField id="description" wide label={translate("documentData.supplierName")}
                               value={details.description}/>}
        {details.submitterName &&
            <DocumentDataField id="submitterName" label={translate("documentData.submitterName")}
                               value={details.submitterName}/>}
        {!!details.createdDate &&
            <DocumentDataField id="createdDate" label={translate("documentData.createdDate")}
                               value={formatDate(details.createdDate, null)}/>}
        {details.category &&
            <DocumentDataField id="category" label={translate("documentData.category")} value={details.category}/>}
        <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={getDisplayId(details)}/>
        {details.corporateData &&
            <DocumentDataField id="corporateData" label={translate("documentData.corporateId")} value={details.corporateData}/>}
        {details.address &&
            <DocumentDataField id="address" label={translate("documentData.address")} value={details.address}/>}
        {details.contactInfo &&
            <DocumentDataField id="contactInfo" label={translate("documentData.phone")} value={details.contactInfo}/>}
        {details.gln &&
            <DocumentDataField id="gln" label={translate("documentData.gln")} value={details.gln}/>}
        {details.bankData &&
            <DocumentDataField id="bankData" label={translate("documentData.bankAccount")} value={details.bankData}/>}
        {details.termsOfPayments &&
            <DocumentDataField id="termsOfPayments" label={translate("documentData.paymentTerms")}
                               value={details.termsOfPayments}/>}
        {details.documentOrganizationUnit &&
            <DocumentDataField id="organizationUnit" label={translate("documentData.organizationUnit")}
                               value={formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>}
    </DocumentDataGrid>
);

export default SupplierDocumentDetailsDTO;
